module.exports = __webpack_public_path__ + "img/service-9.ef85b6b7.gif";